export * from '../_internal/operators/isProsemirror';
export { isPotentiallyRecoverableEditorCrash } from '../_internal/operators/isPotentiallyRecoverableEditorCrash';